import { initializeApp } from "firebase/app";
import { getFirestore } from "firebase/firestore";
import { getStorage } from "firebase/storage";
// import { getAuth } from "firebase/auth"; // Removed unused auth

// Your web app's Firebase configuration
const firebaseConfig = {
  apiKey: "AIzaSyBVQek0x3j7rZbIIQKAWFk83-qjdtmxXMU",
  authDomain: "tools-games-f4684.firebaseapp.com",
  projectId: "tools-games-f4684",
  storageBucket: "tools-games-f4684.firebasestorage.app",
  messagingSenderId: "269223102421",
  appId: "1:269223102421:web:b261cf1a265b696fdf9f5c"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig); 
const db = getFirestore(app);
const storage = getStorage(app);
// const auth = getAuth(app); // Removed unused auth

export { db, storage };
